import React, {useState} from 'react';
import { Button, Badge } from 'react-bootstrap';
import './Counter.css';
import { useContext } from 'react';
import SimpleContext from './../../context//SimpleContext';

const Counter3 = ({min, max, numUnit, unit, fresh, price, slug, name, stock, numSale, goodsRef, uniqueid}) => {

    const context = useContext(SimpleContext);
    const [num, setNum] = useState(0);
    const increment = () => {

        if (stock === 0 || stock === numSale){
            context.HandelShowContentPage('11')
        }else{
            context.handleAddFRESHProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale, unit})
            context.FRESHbadgeNum(slug)
            setNum(context.PrdCount);
            if(num === 0){
                setNum(min)
            }else{
                setNum(num + 1)
            }
            if (num === max) {
                setNum(max)
                context.HandelShowContentPage('7')
            }
        }
    };
    const decrement = () => {
        context.handleRemoveFRESHProduct({min, max, name, slug, goodsRef, uniqueid, price, num:{num}, numUnit, numSale,unit})
        setNum(num - 1);
        if (num === min ){
            setNum(0);
        }else{
            setNum(num - 1)
        }
        if(num === min){
            setNum(0)
            context.handleDeleteFRESHItemFromSabad(slug)
        }
    };

    const FreshExistChecker = () => {
        let badge = 0;
        const ex = context.FRESHCartItems.filter(item => item.slug === slug)
        if (ex.length > 0) {
            return badge = parseInt(ex.map(i=>i.ProCount))
        }else{
            return badge = 0
        }
    }
   
    
    return ( 
        <>            
            {
                num > stock-1?
                <Button
                variant="success"
                className="btn btn-sm Dialogplusbtn fa fa-plus"
                onClick={() =>context.HandelShowContentPage('7')}
                />
                :
                <Button
                    variant="success"
                    className="btn btn-sm Dialogplusbtn fa fa-plus"
                    onClick={increment}
                />
            }
            {
                FreshExistChecker() > 0?
                    <>
                        <Badge className="Dialogbadgbtn">
                            <p>
                                {FreshExistChecker()}{unit}
                            </p>
                        </Badge>
                        <Button
                            variant="success"
                            onClick={decrement}
                            className='minusbtn'>
                            <i className="fa fa-minus"></i>
                        </Button>
                    </>

                :
                    null

            }
            {/* {
                num>0?
                <React.Fragment>
                    <Badge className="Dialogbadgbtn">
                        <p>
                            {num} {unit} 
                        </p>
                    </Badge>
                    {
                        0<num<min?
                        <Button
                            variant="success"
                            className="btn btn-sm minusbtn fa fa-minus"
                            onClick={decrement}
                        />
                        :
                        null
                    } 
                </React.Fragment>
                :null
            } */}
        </>
     );
}
 
export default Counter3;